__turbopack_context__.v({
  "EMIOptions": "EMIOptions-module__Pp-UDG__EMIOptions",
  "active": "EMIOptions-module__Pp-UDG__active",
  "bankName": "EMIOptions-module__Pp-UDG__bankName",
  "bankNames": "EMIOptions-module__Pp-UDG__bankNames",
  "contents": "EMIOptions-module__Pp-UDG__contents",
  "icon": "EMIOptions-module__Pp-UDG__icon",
  "left": "EMIOptions-module__Pp-UDG__left",
  "right": "EMIOptions-module__Pp-UDG__right",
  "table": "EMIOptions-module__Pp-UDG__table",
  "title": "EMIOptions-module__Pp-UDG__title",
});
